import styled from 'styled-components'

export const AdContainer = styled.div`
  text-align: center;
  padding: 20px;
  background-color: rgb(248, 244, 236, 0.3);
`;